import styled from '@emotion/styled';
import { InboxDocument } from 'store/inbox/inboxApi';

import { DocumentCard } from './document-card';

type DocumentsListProp = {
  documents: InboxDocument[];
  isDocumentDownloading: boolean;
  onDownload: (document: InboxDocument) => void;
};

const S = {
  Cards: styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
  `,
  SessionWrapper: styled.div`
    padding: 20px;
    background-color: #f4f4f4;
    border-radius: 16px;
    margin-top: 10px;
  `,
  SessionInfo: styled.h4`
    padding: 10px 0 20px 10px;
    font-family: 'Arial';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 130%;
    color: #23085a;
    margin: 0px;
  `,
};

export const DocumentsList = ({ documents, onDownload, isDocumentDownloading }: DocumentsListProp) => {
  const groupedDocuments = documents.reduce((agg, curr) => {
    const key = `${curr.sessionName} (${curr.awardingBodyName})`;

    (agg[key] = agg[key] || []).push(curr);

    return agg;
  }, {} as Record<string, InboxDocument[]>);

  return (
    <>
      {Object.entries(groupedDocuments).map(([sessionAndAwardingBodyName, value]) => (
        <S.SessionWrapper key={sessionAndAwardingBodyName}>
          <S.SessionInfo>{sessionAndAwardingBodyName}</S.SessionInfo>
          <S.Cards>
            {value.map((document) => (
              <DocumentCard
                {...document}
                key={`${document.id}${document.candidateId}`}
                onDownload={() => onDownload(document)}
                isDownloadingEnabled={isDocumentDownloading}
              />
            ))}
          </S.Cards>
        </S.SessionWrapper>
      ))}
    </>
  );
};
